import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RedliningAcknowledgeModel } from '../models/classes/acknowledgement';
import { Attachment } from '../models/classes/attachment';
import { Redlining } from '../models/classes/redlining';
import { PresetModel } from '../models/classes/preset';

@Injectable({
  providedIn: 'root',
})

export class RedliningService {
  ip = environment.ipServer;
  private userUrl = `${this.ip}/api/redlining`;
  redLiningRef: BehaviorSubject<Redlining[]>;
  redRef: Redlining[] = [];

  private reds: BehaviorSubject<Redlining[]>;
  redlines: Redlining[] = [];
  constructor(private http: HttpClient) {
    this.redLiningRef = new BehaviorSubject<Redlining[]>([]);
    this.reds = new BehaviorSubject<Redlining[]>([]);
  }

  getRedlinings(): Observable<Redlining[]> {
    return this.http.get<Redlining[]>(this.userUrl).pipe(
      map((data) => (this.redlines = data)),
      catchError(this.handleError)
    );
  }

  getDeviceRedlinings(id: string): Observable<Redlining[]> {
    const url = `${this.ip}/api/redlining/GetDevice/${id}`;
    return this.http.get<Redlining[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getUserRedlinings(id: number): Observable<Redlining[]> {
    const url = `${this.ip}/api/redlining/GetUser/${id}`;
    return this.http.get<Redlining[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getRedlining(id: number): Observable<Redlining> {
    const url = `${this.ip}/api/redlining/${id}`;
    return this.http.get<Redlining>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getRedliningAttachments(id: number): Observable<Attachment[]> {
    const url = `${this.ip}/api/redlining/GetAttachments/${id}`;
    return this.http.get<Attachment[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }
  getTodaysRedlining(): Observable<Redlining[]> {
    const url = `${this.ip}/api/redlining/GetTodays`;
    return this.http.get<Redlining[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getPresets(): Observable<PresetModel[]> {
    const url = `${this.ip}/api/preset`;
    return this.http.get<PresetModel[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  ackRedlining(ack: RedliningAcknowledgeModel) {
    const url = `${this.ip}/api/redlining/AcknowledgeRedlining`;
    return this.http
      .post(url, ack, { observe: 'response' });
  }

  redliningPreset(preset: PresetModel) {
    const url = `${this.ip}/api/preset`;
    return this.http
      .post(url, preset, { observe: 'response' });
  }

  updateRedliningPreset(id:number,preset: PresetModel) {
    const url = `${this.ip}/api/preset/UpdatePreset/${id}`;
    return this.http
      .put(url, preset, { observe: 'response' });
  }

  deleteRedliningPreset(id:number,preset: PresetModel) {
    const url = `${this.ip}/api/preset/DeletePreset/${id}`;
    return this.http
      .delete(url, { observe: 'response' });
  }

  deleteRedlining(id: number[]){
    const url = `${this.ip}/api/Redlining/DeleteRedlinings`;
    return this.http
      .delete(url, { observe: 'response', body: id });
  }

  getBuilding(id: number) {
    const url = `${this.ip}/api/building/getbuilding/${id}`;
    return this.http.get(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getDuct(id: number) {
    const url = `${this.ip}/api/Duct/GetDuctFromKey/${id}`;
    return this.http.get(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getCable(id: number) {
    const url = `${this.ip}/api/cable/getcable/${id}`;
    return this.http.get(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getFloor(id: number) {
    const url = `${this.ip}/api/floor/GetFloorById/${id}`;
    return this.http.get(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }
  getRoom(id: number) {
    const url = `${this.ip}/api/room/GetRoomById/${id}`;
    return this.http.get(url).pipe(
      tap((data) =>data),
      catchError(this.handleError)
    );
  }

  getRack(id: number) {
    const url = `${this.ip}/api/rack/GetRackById/${id}`;
    return this.http.get(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getComponent(id: number) {
    const url = `${this.ip}/api/component/GetRedliningComponent/${id}`;
    return this.http.get(url,{responseType:"text"}).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }
  getComponentPort(id: number) {
    const url = `${this.ip}/api/component/GetRedliningComponentPort/${id}`;
    return this.http.get(url,{responseType:"text"}).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }
 
  getService(id: number) {
    const url = `${this.ip}/api/service/GetService/${id}`;
    return this.http.get(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  get devRef(): Observable<Redlining[]> {
    return this.redLiningRef.asObservable();
  }

  get redLines(): Observable<Redlining[]> {
    return this.reds.asObservable();
  }
  
  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;

    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
